import {Enum} from 'enumify'
import * as d3 from 'd3';

class ChartZoomDirection extends Enum {}
ChartZoomDirection.initEnum(['X', 'Y', 'XY']);
export { ChartZoomDirection} ;

class ChartAxisDirection extends Enum {}
ChartAxisDirection.initEnum({

    HORIZONTAL: { 
        
        className: "horizontal",
        d3Axis: (scale) => {
            return d3.axisBottom(scale)
        },
        rescale: (scale, transform) => {
            return transform.rescaleX(scale)
        },
        range: (size) => {
            return [0, size.width]
        },
        defaultDomain: () => {
            return [new Date(2012,0,1), new Date(2012,0,31)]
        },
        applyTickFormat: (scale) => {
            return scale.tickFormat(d3.timeFormat("%a %d"))
        },
        defaultScale: d3.scaleLinear
    },

    VERTICAL: { 
        className: "vertical",
        d3Axis: (scale) => {
            return d3.axisRight(scale)
        },
        rescale: (scale) => {
            return d3.event.transform.rescaleY(scale)
        },
        range: (size) => {
            return [size.height, 0]
        },
        defaultDomain: () => {
            return [100, 10000]
        },
        applyTickFormat: (scale) => {
            return scale.tickFormat(d3.format(".2f"))
        },
        defaultScale: d3.scaleLog
    },
})

export default ChartAxisDirection;


// WEBPACK FOOTER //
// ./src/ChartAxisDirection.js